import { CKButton } from '@clearkit/react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Add from '@material-ui/icons/Add';
import startCase from 'lodash/startCase';

import styles from './AddField.style';
import { LABEL_FOR_FIELD_TYPE } from './Utils';

class AddField extends React.Component {
  state = {
    createFieldPopover: false,
  };

  createFieldPopoverOpen = (event) => {
    event.preventDefault();

    this.setState({
      createFieldPopover: true,
      createFieldPopoverAnchor: event.currentTarget,
    });
  };

  createFieldPopoverClose = () => {
    this.setState({
      createFieldPopover: false,
    });
  };

  existingInternalNames = () => {
    const { form } = this.props;

    return form.fields.map((field) => field.slug);
  };

  getDefaultInternalName = (type) => {
    let slug = type;

    if (this.existingInternalNames().indexOf(type) === -1) {
      return slug;
    }

    let attempt = 0;

    do {
      attempt += 1;
      slug = `${type}_${attempt}`;
    } while (this.existingInternalNames().indexOf(slug) !== -1);

    return slug;
  };

  getDefaultLabel = (type) => {
    if (type === 'country_code') return 'Country';

    return startCase(type);
  };

  createField = (type) => {
    this.createFieldPopoverClose();
    const slug = this.getDefaultInternalName(type);
    const label = this.getDefaultLabel(type);

    this.props.addField({ type, slug, label });
  };

  render() {
    const { classes } = this.props;
    const { createFieldPopover, createFieldPopoverAnchor } = this.state;

    return (
      <div className={classes.root}>
        <Menu
          open={createFieldPopover}
          anchorEl={createFieldPopoverAnchor}
          onClose={this.createFieldPopoverClose}>
          {Object.entries(LABEL_FOR_FIELD_TYPE).map(([field_type, label]) => (
            <MenuItem
              key={field_type}
              onClick={() => this.createField(field_type)}>
              {label}
            </MenuItem>
          ))}
        </Menu>

        <CKButton
          variant="bold"
          variantColor="blue"
          onClick={this.createFieldPopoverOpen}>
          <Add /> <span>Add field</span>
        </CKButton>
      </div>
    );
  }
}

AddField.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  addField: PropTypes.func.isRequired,
};

export default withStyles(styles)(AddField);
